export default function SecondaryButton({ children, ...props }) {
  return (
    <button
      className="inline-flex items-center justify-center rounded-2xl px-4 py-2 text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-100 transition"
      {...props}
    >
      {children}
    </button>
  );
}
